module.exports = __webpack_public_path__ + "img/3.71b69a9c.svg";